import React from 'react'
import { NavLink } from 'react-router-dom'
import { SlHome } from 'react-icons/sl'
import { BsWallet, BsGift } from 'react-icons/bs'
import { FiUser, FiUsers } from 'react-icons/fi'
import { AiOutlineMessage } from 'react-icons/ai'
import { BiMessageSquareDetail } from 'react-icons/bi'

const BottonMenu = ({ w3_close }) => {
  return (
    <div className="bottom_nav_wrapper">
      <div className="bottom_nav_bar">

        <NavLink exact to="/wallet" className="nav_item" activeClassName="active">
          <img src="/wallet.png" alt="" />
        </NavLink>

        <NavLink exact to="/refer" className="nav_item" activeClassName="active">
          <img src="/bootom-refer.png" alt="" style={{marginRight:"60px"}} />
        </NavLink>
       

        {/* CENTER HOME BUTTON */}
        <NavLink exact to="/landing" className="center_button" activeClassName="active_center">
          <img src="/home.png" alt="" />
        </NavLink>

        <NavLink exact to="/support" className="nav_item" activeClassName="active">
          <img src="/customer-support.png" alt="" />
        </NavLink>

        <NavLink exact to="/Profile" className="nav_item" activeClassName="active">
          <img src="/bootom_user.png" alt="" />
        </NavLink>

      </div>
    </div>

  )
}

export default BottonMenu
